define('webshopAttributesSupplierValuesView',[
  'module',
  'marionette',
  'underscore',
  'modalsAlertView',
  'webshopAttributesValueAutocomplete',
  'entities/webshop/attribute_matching',
  'template!webshopAttributesSupplierValuesView'
], function (
  Module,
  Marionette,
  _,
  AlertView,
  ValueAutocomplete,
  MatchingApi,
  Tpl
) {
  'use strict';

  var PAGE_SIZE = 50;

  // Values of the supplier fields matched to one attribute, with the canonical value each one is
  // shown as (attribute matching) and the up to three values it is filtered under (filter matching),
  // each picked in an autocomplete that suggests first the values closest to the supplier value.
  // A change is saved at once. options: key, values (canonical values, kept up to date by the
  // parent), meta {suppliers}, onChanged() (match counts / new values to reload).
  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'webshop-attributes-supplier-values-view',

    ui: {
      search: 'input.search',
      supplier: 'select.supplier',
      unmatched: 'input.unmatched',
      list: '.rows',
      pager: '.am-pager',
      bulkValue: 'input.bulk-value',
      selectedCount: '.selected-count',
      checkAll: 'input.check-all'
    },

    events: {
      'input @ui.search': 'onFilterChange',
      'change @ui.supplier': 'onFilterChange',
      'change @ui.unmatched': 'onFilterChange',
      'focus input.am-ac': 'onFocusCell',
      'click .create-value': 'onCreateFromSupplier',
      'change input.check': 'onCheck',
      'change @ui.checkAll': 'onCheckAll',
      'click .bulk-apply': 'onBulkApply',  // data-target: attr | 1 | 2 | 3
      'click .prev': 'onPrev',
      'click .next': 'onNext'
    },

    initialize: function () {
      this.first = 0;
      this.total = 0;
      this.rows = [];
      this.checked = {};
      this.bulkValueId = null;
    },

    serializeData: function () {
      return {suppliers: this.options.meta.suppliers || []};
    },

    onRender: function () {
      var state = this.options.state || {};
      this.ui.search.val(state.q || '');
      this.ui.supplier.val(state.sup || '');
      this.ui.unmatched.prop('checked', !!state.unm);
      this.fetch();
    },

    labels: function () {
      return MatchingApi.labels(this.options.values);
    },

    fetch: function () {
      var request = MatchingApi.supplierValues(this.options.key.id, {
        search: this.ui.search.val(),
        supplier: this.ui.supplier.val(),
        unmatched: this.ui.unmatched.is(':checked'),
        first: this.first,
        pageSize: PAGE_SIZE
      });
      this.request = request;
      this.$('.table').addClass('am-loading');
      request.done(_.bind(function (page) {
        if (this.isDestroyed || request !== this.request)
          return;
        this.total = page.total;
        this.rows = page.items;
        this.renderRows();
      }, this)).fail(_.bind(this.showError, this)).always(_.bind(function () {
        if (!this.isDestroyed && request === this.request)
          this.$('.table').removeClass('am-loading');
      }, this));
    },

    getRow: function (id) {
      return _.findWhere(this.rows, {customFieldValueId: id});
    },

    // Input of one cell: kind 'attr' (shown as) or 'filter' (idx 0..2).
    cellHtml: function (row, kind, idx) {
      var id = kind === 'attr' ? row.valueKeyId : (row.filterValueKeyIds || [])[idx];
      return '<input type="text" class="am-ac am-input ' + kind + '-value" data-kind="' + kind + '"' +
        (kind === 'filter' ? ' data-idx="' + idx + '"' : '') +
        ' value="' + _.escape(id ? this.labels()[id] || '' : '') + '" placeholder="—"/>';
    },

    renderRows: function () {
      var html = _.map(this.rows, function (r) {
        var matched = r.valueKeyId || _.compact(r.filterValueKeyIds || []).length;
        return '<div class="row ' + (matched ? '' : 'unmatched') + '" data-id="' + r.customFieldValueId + '">' +
          '<div class="col-check"><input type="checkbox" class="check" ' + (this.checked[r.customFieldValueId] ? 'checked' : '') + '/></div>' +
          '<div class="col-supplier" title="' + _.escape(r.fieldCode) + '">' + _.escape(r.supplierCode) + '<div class="field">' + _.escape(r.fieldCode) + '</div></div>' +
          '<div class="col-label">' + (r.color ? '<span class="am-swatch" style="background:' + _.escape(r.color) + '"></span> ' : '') +
          _.escape(r.label || r.code) +
          (matched ? '' : ' <span class="create-value" title="' + _.escape(_.i18n('attributeMatching.createFromSupplier', null, 'Create a value with this name and match it')) + '"><i class="fa fa-plus-circle"></i></span>') +
          '</div>' +
          '<div class="col-attr">' + this.cellHtml(r, 'attr') + '</div>' +
          _.map([0, 1, 2], function (i) { return '<div class="col-filter">' + this.cellHtml(r, 'filter', i) + '</div>'; }, this).join('') +
          '</div>';
      }, this).join('');

      this.ui.list.html(html || '<div class="empty">' + _.i18n('attributeMatching.noSupplierValue', null, 'No supplier value (match supplier fields first)') + '</div>');

      var last = Math.min(this.first + PAGE_SIZE, this.total);
      this.ui.pager.html(
        '<span class="prev ' + (this.first > 0 ? '' : 'off') + '"><i class="fa fa-chevron-left"></i></span>' +
        '<span>' + (this.total ? this.first + 1 : 0) + '–' + last + ' / ' + this.total + '</span>' +
        '<span class="next ' + (last < this.total ? '' : 'off') + '"><i class="fa fa-chevron-right"></i></span>');
      this.ui.checkAll.prop('checked', false);
      this.renderSelected();
      this.attachBulk();
    },

    //----------------
    // Cells (autocomplete attached on first focus: 200 inputs per page)

    onFocusCell: function (e) {
      var $input = $(e.currentTarget);
      if ($input.data('amAttached') || $input.hasClass('bulk-value'))
        return;
      $input.data('amAttached', true);
      var id = parseInt($input.closest('.row').data('id'), 10);
      var kind = $input.data('kind');
      var idx = parseInt($input.data('idx'), 10);
      var row = this.getRow(id);

      ValueAutocomplete.attach($input, {
        values: _.bind(function () { return this.options.values; }, this),
        references: [row.label, row.code],
        count: kind,
        currentId: function () {
          return kind === 'attr' ? row.valueKeyId : (row.filterValueKeyIds || [])[idx] || null;
        },
        onPick: _.bind(function (valueId) { this.pick(row, kind, idx, valueId); }, this),
        onCreate: _.bind(function (name) {
          this.createValue(name, row.color).done(_.bind(function (value) { this.pick(row, kind, idx, value.id); }, this));
        }, this)
      });
      $input.select();
      $input.amValueComplete('search', '');
    },

    // Saves the choice of one cell. A supplier value shown as X is filtered under X too, unless it
    // already has filter values.
    pick: function (row, kind, idx, valueId) {
      var filters = (row.filterValueKeyIds || []).slice(0, 3);
      while (filters.length < 3)
        filters.push(null);
      var data = {customFieldValueIds: [row.customFieldValueId]};
      if (kind === 'attr') {
        data.updateAttribute = true;
        data.valueKeyId = valueId;
        data.updateFilters = false;
        if (valueId && !_.compact(filters).length) {
          filters[0] = valueId;
          data.updateFilters = true;
          data.filterValueKeyIds = filters;
        }
        row.valueKeyId = valueId;
      } else {
        filters[idx] = valueId;
        data.updateAttribute = false;
        data.updateFilters = true;
        data.filterValueKeyIds = filters;
      }
      row.filterValueKeyIds = filters;
      this.save(data).always(_.bind(this.renderRow, this, row));
    },

    renderRow: function (row) {
      if (this.isDestroyed)
        return;
      var $row = this.ui.list.find('.row[data-id="' + row.customFieldValueId + '"]');
      var matched = row.valueKeyId || _.compact(row.filterValueKeyIds || []).length;
      $row.toggleClass('unmatched', !matched);
      $row.find('.create-value').toggle(!matched);
      var labels = this.labels();
      $row.find('input.attr-value').val(row.valueKeyId ? labels[row.valueKeyId] || '' : '');
      $row.find('input.filter-value').each(function () {
        var id = (row.filterValueKeyIds || [])[parseInt($(this).data('idx'), 10)];
        $(this).val(id ? labels[id] || '' : '');
      });
    },

    save: function (data) {
      return MatchingApi.matchValues(this.options.key.id, data).done(_.bind(function () {
        if (this.options.onChanged)
          this.options.onChanged();
      }, this)).fail(_.bind(function (message) {
        this.showError(message);
        this.fetch();
      }, this));
    },

    // New canonical value (or the existing one with that name / code).
    createValue: function (name, color) {
      var lower = name.toLowerCase();
      var existing = _.find(this.options.values, function (v) {
        return v.code.toLowerCase() === lower || MatchingApi.name(v).toLowerCase() === lower;
      });
      if (existing)
        return $.Deferred().resolve(existing).promise();
      return MatchingApi.addValue(this.options.key.id, {code: name, names: {en: name}, extraParam1: color || ''})
        .done(_.bind(function (value) {
          this.options.values.push(value);
        }, this)).fail(_.bind(this.showError, this));
    },

    onCreateFromSupplier: function (e) {
      var row = this.getRow(parseInt($(e.currentTarget).closest('.row').data('id'), 10));
      this.createValue(row.label || row.code, row.color).done(_.bind(function (value) {
        this.save({
          customFieldValueIds: [row.customFieldValueId],
          updateAttribute: true,
          valueKeyId: value.id,
          updateFilters: true,
          filterValueKeyIds: [value.id]
        }).done(_.bind(this.fetch, this));
      }, this));
    },

    //----------------
    // Bulk

    attachBulk: function () {
      if (this.ui.bulkValue.data('amAttached'))
        return;
      this.ui.bulkValue.data('amAttached', true);
      ValueAutocomplete.attach(this.ui.bulkValue, {
        values: _.bind(function () { return this.options.values; }, this),
        count: 'both',
        // Suggestions from the selected supplier values' labels
        references: _.bind(function () {
          return _.flatten(_.map(_.keys(this.checked), function (id) {
            var row = this.getRow(parseInt(id, 10));
            return row ? [row.label, row.code] : [];
          }, this));
        }, this),
        currentId: _.bind(function () { return this.bulkValueId; }, this),
        noClear: false,
        // Picking (a value, or "— No matching" to remove) enables the apply buttons
        onPick: _.bind(function (valueId) {
          this.bulkValueId = valueId;
          this.bulkPicked = true;
          this.renderSelected();
        }, this),
        onCreate: _.bind(function (name) {
          this.createValue(name).done(_.bind(function (value) {
            this.bulkValueId = value.id;
            this.bulkPicked = true;
            this.ui.bulkValue.val(this.labels()[value.id]);
            this.renderSelected();
          }, this));
        }, this)
      });
    },

    onCheck: function (e) {
      var id = parseInt($(e.currentTarget).closest('.row').data('id'), 10);
      if ($(e.currentTarget).is(':checked'))
        this.checked[id] = true;
      else
        delete this.checked[id];
      this.renderSelected();
    },

    onCheckAll: function () {
      var on = this.ui.checkAll.is(':checked');
      _.each(this.rows, function (r) {
        if (on)
          this.checked[r.customFieldValueId] = true;
        else
          delete this.checked[r.customFieldValueId];
      }, this);
      this.$('input.check').prop('checked', on);
      this.renderSelected();
    },

    renderSelected: function () {
      var count = _.keys(this.checked).length;
      this.ui.selectedCount.text(count);
      this.$('.bulk').toggleClass('off', count === 0);
      this.$('.bulk-apply').toggleClass('disabled', !this.bulkPicked);
    },

    // The chosen value (empty: removes) as "Shown as", or as Filter N only, of the selected
    // supplier values; their other matchings are kept.
    onBulkApply: function (e) {
      var ids = _.map(_.keys(this.checked), function (id) { return parseInt(id, 10); });
      if (!ids.length || !this.bulkPicked)
        return;
      var target = String($(e.currentTarget).data('target'));
      var value = this.bulkValueId;
      var data = {customFieldValueIds: ids};
      if (target === 'attr') {
        data.updateAttribute = true;
        data.valueKeyId = value;
        data.updateFilters = false;
      } else {
        data.updateAttribute = false;
        data.updateFilters = false;
        data.filterIdx = parseInt(target, 10);
        data.filterValueKeyId = value;
      }
      this.save(data).done(_.bind(function () {
        this.checked = {};
        this.fetch();
      }, this));
    },

    //----------------
    // Filters / paging

    onFilterChange: function () {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(_.bind(function () {
        this.first = 0;
        this.checked = {};
        if (this.options.onState)
          this.options.onState({q: this.ui.search.val(), sup: this.ui.supplier.val(), unm: this.ui.unmatched.is(':checked')});
        this.fetch();
      }, this), 300);
    },

    onPrev: function (e) {
      if ($(e.currentTarget).hasClass('off'))
        return;
      this.first = Math.max(0, this.first - PAGE_SIZE);
      this.fetch();
    },

    onNext: function (e) {
      if ($(e.currentTarget).hasClass('off'))
        return;
      this.first += PAGE_SIZE;
      this.fetch();
    },

    showError: function (message) {
      AlertView.prototype.open('', message);
    }
  });
});

